import { render } from "./ToolPage.vue?vue&type=template&id=50f70a5f"
import script from "./ToolPage.vue?vue&type=script&lang=js"
export * from "./ToolPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__